
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitoalibaugcab() {



    const cardData =
    {
        keyword: ' Mumbai to Alibaug Cab  ',
        heading: 'Deva Cabs: Mumbai to Alibaug Cab ',
        headingDescription: 'Deva Cabs provides quick and comfortable cab services from Mumbai to Alibaug, perfect for beach holidays, weekend getaways, and family outings. Located just 95 km from Mumbai, Alibaug is a popular coastal destination, and our cabs ensure a smooth ride through scenic routes. Choose from Sedans, SUVs, or Innova Crysta, all driven by courteous and experienced drivers. With fixed fares, flexible pickup options, and 24/7 availability, Deva Cabs makes your Mumbai to Alibaug trip relaxed and hassle-free.',

        top: 'Top Places to Visit in Alibaug with Deva Cabs',

"topPlaces": [
  {
    "title": "Alibaug Beach",
    "location": "Alibaug, Maharashtra",
    "description": "Alibaug Beach is the most visited beach in the town, known for its black sand and views of the historic Kolaba Fort. It's perfect for leisurely walks, horseback rides, and witnessing stunning sunsets. During low tide, visitors can even walk up to the fort through the shallow waters."
  },
  {
    "title": "Kolaba Fort",
    "location": "Off Alibaug Beach, Maharashtra",
    "description": "Kolaba Fort is a 17th-century sea fort built by Chhatrapati Shivaji Maharaj. Accessible by foot during low tide, it features ancient temples, freshwater wells, and cannons. The fort offers panoramic views of the Arabian Sea and is a top historical attraction in Alibaug."
  },
  {
    "title": "Kihim Beach",
    "location": "Kihim, Alibaug, Maharashtra",
    "description": "Kihim Beach is known for its soft sands, coconut trees, and peaceful environment. It’s popular among nature lovers and photographers due to its variety of butterflies and migratory birds. The beach is also dotted with homestays and is ideal for quiet getaways."
  },
  {
    "title": "Nagaon Beach",
    "location": "Nagaon, Alibaug, Maharashtra",
    "description": "Nagaon Beach is famous for water sports such as banana rides, parasailing, and jet skiing. The beach is clean, wide, and relatively less crowded, making it a favorite among families and adventure enthusiasts. Many resorts and cottages are located nearby."
  },
  {
    "title": "Murud-Janjira Fort",
    "location": "Murud, Near Alibaug, Maharashtra",
    "description": "Located on an island off the coast of Murud, Janjira Fort is an architectural marvel that remained unconquered by the British, Portuguese, or Marathas. Known for its 19 bastions and secret escape routes, it is accessible via sailboats and offers a unique historic experience."
  },
  {
    "title": "Varsoli Beach",
    "location": "Varsoli, Alibaug, Maharashtra",
    "description": "Varsoli Beach is a quiet and lesser-known spot, ideal for relaxing in a serene setting. Lined with palm trees and clean sands, it’s perfect for morning walks, peaceful sunsets, and staying in beachfront cottages. The beach is also used by local fishermen."
  },
  {
    "title": "Kanakeshwar Forest and Temple",
    "location": "Near Alibaug, Maharashtra",
    "description": "Located atop a hill, Kanakeshwar Temple is dedicated to Lord Shiva and involves a climb of over 700 steps through a forest. The panoramic view from the top and the peaceful surroundings make it a spiritual and trekking hotspot near Alibaug."
  },
  {
    "title": "Akshi Beach",
    "location": "Akshi, Alibaug, Maharashtra",
    "description": "Akshi Beach is a peaceful stretch known for its clean shoreline, calm waters, and coconut groves. Ideal for long walks and bird watching, it is popular among couples and solo travelers looking for solitude away from the crowd."
  },
  {
    "title": "Revdanda Beach and Fort",
    "location": "Revdanda, Near Alibaug, Maharashtra",
    "description": "Revdanda Beach is a beautiful and less-commercial beach known for its dark sand and casuarina trees. The nearby Revdanda Fort, built by the Portuguese, adds historical charm and is great for exploration and photography during sunset hours."
  },
  {
    "title": "Kashid Beach",
    "location": "Kashid, Near Alibaug, Maharashtra",
    "description": "Kashid Beach is known for its white sand, crystal-clear waters, and scenic landscapes. It’s perfect for water sports, camping, and picnics. Located about 30 km from Alibaug, it’s ideal for a day trip or overnight stay with beautiful views and clean surroundings."
  }
],



"services": [
  {
    "name": "Mumbai to Alibaug Cab",
    "description": "Travel comfortably from Mumbai to the beautiful coastal town of Alibaug with our reliable cab services. Perfect for family outings, weekend getaways, or corporate trips, our Mumbai to Alibaug cabs offer a smooth, hassle-free journey along scenic routes with timely pickups and friendly chauffeurs."
  },
  {
    "name": "One-way taxi Mumbai to Alibaug",
    "description": "Choose our convenient one-way taxi service from Mumbai to Alibaug for flexible travel plans. Whether you’re heading to Alibaug for a day trip or longer stay, our one-way cabs provide affordable and comfortable transport without the need to worry about return arrangements."
  },
  {
    "name": "Round trip cab Mumbai to Alibaug",
    "description": "Book a round trip cab for your Mumbai to Alibaug excursion and enjoy the ease of a single booking covering both onward and return journeys. Ideal for weekend trips, this service ensures punctuality, fixed pricing, and the comfort of a dedicated vehicle at your disposal."
  },
  {
    "name": "SUV cab hire Mumbai to Alibaug",
    "description": "Travel in style and space with our SUV cabs for Mumbai to Alibaug. Perfect for families or groups with extra luggage, our SUVs offer ample room, robust performance on varied road conditions, and a comfortable ride so you arrive relaxed and ready to enjoy your trip."
  },
  {
    "name": "AC cab Mumbai to Alibaug beach",
    "description": "Enjoy a refreshing, air-conditioned ride from Mumbai to Alibaug’s serene beaches. Our AC cabs ensure a cool and pleasant journey, shielding you from the summer heat while you travel through beautiful coastal landscapes."
  },
  {
    "name": "Chauffeur cab Mumbai to Alibaug",
    "description": "Relax and leave the driving to us with our professional chauffeur-driven cabs from Mumbai to Alibaug. Our experienced drivers provide safe and timely transfers, along with local insights to enhance your beach getaway or business visit."
  },
  {
    "name": "Affordable Alibaug taxi Mumbai",
    "description": "Looking for cost-effective transport from Mumbai to Alibaug? Our affordable taxi options offer the best balance of price and quality, delivering reliable service without compromising comfort or safety."
  },
  {
    "name": "Family cab Mumbai to Alibaug",
    "description": "Make your family trips to Alibaug special with our spacious and comfortable family cabs. We provide child-friendly options, plenty of luggage space, and courteous service, ensuring a smooth journey for all ages."
  },
  {
    "name": "Book cab Mumbai to Alibaug online",
    "description": "Plan your trip effortlessly by booking your Mumbai to Alibaug cab online. Our easy-to-use platform lets you select your preferred vehicle, timing, and route, with instant confirmation and 24/7 customer support."
  },
  {
    "name": "Weekend cab trip Mumbai to Alibaug",
    "description": "Escape the city hustle with our weekend cab trips from Mumbai to Alibaug. Perfect for short vacations or leisure breaks, our weekend packages include flexible timings, comfortable vehicles, and the option for sightseeing en route."
  }
],
"tableData": [
  ["Mumbai to Alibaug Cab", "-One-way taxi Mumbai to Alibaug"],
  ["Round trip cab Mumbai to Alibaug", "-SUV cab hire Mumbai to Alibaug"],
  ["AC cab Mumbai to Alibaug beach", "-Chauffeur cab Mumbai to Alibaug"],
  ["Affordable Alibaug taxi Mumbai", "-Family cab Mumbai to Alibaug"],
  ["Book cab Mumbai to Alibaug online", "-Weekend cab trip Mumbai to Alibaug"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Alibaug Cab Service",
    "WhyChoosedescription": "Travel from Mumbai to the serene coastal town of Alibaug with our dependable cab service. Ideal for day trips, weekend getaways, or special occasions, we ensure timely pickups and a comfortable, stress-free journey. Our professional approach guarantees a seamless travel experience, so you can focus on enjoying your trip."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Short and Medium Distance",
    "WhyChoosedescription": "Our fleet includes well-maintained, air-conditioned vehicles offering spacious seating and ample luggage space. Covering approximately 95 kilometers, the ride to Alibaug is made relaxing and enjoyable, whether you’re traveling solo, with family, or in a group. Experience comfort and convenience tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Alibaug Route",
    "WhyChoosedescription": "Our drivers have extensive knowledge of the best routes between Mumbai and Alibaug, including the fastest ferry connections if needed. They prioritize safety, punctuality, and passenger comfort, ensuring you arrive promptly and stress-free, even during peak traffic hours."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Enjoy clear pricing without any hidden fees. Our rates include tolls, fuel, and driver allowances, making it easy for you to plan your trip budget confidently. We offer competitive pricing to make your Mumbai to Alibaug travel both economical and convenient."
  },
  {
    "WhyChooseheading": "24/7 Availability to Match Your Schedule",
    "WhyChoosedescription": "Whether you want an early morning start or a late evening return, our cab service operates round the clock. This flexibility lets you plan your Alibaug visit without any timing constraints, ensuring a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Alibaug cab is fast and convenient via our website or customer support. Receive instant confirmation, detailed fare breakdowns, and driver information, so you can travel with complete peace of mind."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "Your safety is our priority. All vehicles undergo regular maintenance and thorough sanitation before each trip. Equipped with seat belts, GPS tracking, and emergency kits, our cabs and drivers adhere to the highest safety standards."
  },
  {
    "WhyChooseheading": "Customizable Travel Packages for Your Convenience",
    "WhyChoosedescription": "We offer flexible travel options including one-way trips, round trips, and customized itineraries with stops at nearby attractions. Whether you are traveling for leisure, events, or business, our service is tailored to fit your specific needs."
  }
]












    }








const faqData = [
  {
    question: "Can I book a cab from Mumbai to Alibaug with Deva Cabs?",
    answer: "Yes, Deva Cabs offers convenient and comfortable cab services from Mumbai to Alibaug for leisure trips, weekend getaways, and more."
  },
  {
    question: "How long does it take to travel from Mumbai to Alibaug by cab?",
    answer: "The journey typically takes around 2 to 3 hours depending on traffic and route."
  },
  {
    question: "What types of vehicles are available for the Mumbai to Alibaug route?",
    answer: "We provide a range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers suitable for solo and group travel."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Alibaug?",
    answer: "Yes, Deva Cabs offers both one-way and round-trip cab services for Mumbai to Alibaug travel."
  },
  {
    question: "Are tolls, parking, and driver charges included in the fare?",
    answer: "Additional charges such as tolls and driver allowances will be clearly communicated during booking."
  },
  {
    question: "Is the Mumbai to Alibaug cab service available 24/7?",
    answer: "Yes, Deva Cabs operates around the clock to accommodate your preferred travel time."
  },
  {
    question: "Is it safe to travel to Alibaug by cab with Deva Cabs?",
    answer: "Absolutely. Our drivers are professional, background-verified, and trained to ensure your safety."
  },
  {
    question: "Can I customize my trip with stops or sightseeing along the way?",
    answer: "Yes, customized trips with sightseeing and stops can be arranged on request."
  },
  {
    question: "Is the cab service suitable for families and groups?",
    answer: "Yes, we have vehicles suitable for families and groups of all sizes, ensuring a comfortable journey."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Alibaug cab service?",
    answer: "Deva Cabs provides reliable vehicles, experienced drivers, transparent pricing, and timely service for a hassle-free trip."
  }
];

const testimonialData = [
  {
    id: 53,
    name: 'Mr. Rohit Mehta',
    role: 'Weekend Traveler',
    review: 'We booked Deva Cabs for a quick trip to Alibaug. The cab was clean, the driver was punctual, and the overall experience was excellent.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 54,
    name: 'Ms. Anjali Sharma',
    role: 'Family Traveler',
    review: 'Our family enjoyed a smooth Mumbai to Alibaug trip with Deva Cabs. The vehicle was spacious and comfortable. Highly recommend!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Alibaug Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-alibaug-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Alibaug cab with Deva Cabs for a comfortable and safe ride. Ideal for day trips, weekend getaways, and special occasions. Choose from hatchbacks, sedans, SUVs, and tempo travellers at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2750"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-alibaug-cab"
  }
};









    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Alibaug Cab | Affordable One Way & Round Trip</title>
  <meta 
    name="description" 
    content="Book Mumbai to Alibaug cab with Deva Cabs for a hassle-free journey. Affordable rates with hatchback, sedan, SUV & tempo traveller options. Perfect for day trips, weekend getaways, and events." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Alibaug Cab, Cab from Mumbai to Alibaug, One Way Taxi Mumbai to Alibaug, Alibaug Cab Service, Mumbai to Alibaug Car Rental, Deva Cabs Alibaug, Affordable Taxi Mumbai to Alibaug, Online Cab Booking Mumbai Alibaug" 
  />
  <link rel="canonical" href="https://devacab.com/mumbai-to-alibaug-cab" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitoalibaugcab;